var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from '@apollo/client';
export var RelatedProductsFragment = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment RelatedProductsFragment on Product {\n    relatedProducts {\n      title\n      subcopy\n      product {\n        url\n      }\n    }\n  }\n"], ["\n  fragment RelatedProductsFragment on Product {\n    relatedProducts {\n      title\n      subcopy\n      product {\n        url\n      }\n    }\n  }\n"])));
export default {};
var templateObject_1;
